import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/home/Hero';
import { StatsBar } from '../components/sections/home/StatsBar';
import { Features } from '../components/sections/home/Features';
import { UseCasesCarousel } from '../components/sections/home/UseCasesCarousel';
import { ComparisonTable } from '../components/sections/home/ComparisonTable';
import { ChatDemo } from '../components/sections/home/ChatDemo';
import { Testimonials } from '../components/sections/home/Testimonials';
import { FAQ } from '../components/sections/home/FAQ';
import { HomeCTA } from '../components/sections/home/HomeCTA';

export default function HomePage() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#020209]">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Features />
        <UseCasesCarousel />
        <ComparisonTable />
        <ChatDemo />
        <Testimonials />
        <FAQ />
        <HomeCTA />
      </main>
      <Footer />
    </div>
  );
}
